import ProxyApi from './_proxyApi.js';

class VersionApplicationApi extends ProxyApi {
  constructor() {
    super();
  }
  controllerName = 'VersionApplication';

  logVersionAsync() {
    try {
      if (!window._log_version_ui) return new Promise(() => { }, () => { });
      const url = [this.getAPIUrl(), 'log'].join('/');
      return this.postAsync({
        url,
        data: {
          env: window._env,
          app_id: 'ui',
          version: window._ui_version,
        },
        isCheckExpiredToken: false
      });
    } catch (ex) {
      console.log(ex);
    }
  }

  logDatabaseIDAsync(trueID, falseID, userID, tenantID) {
    try {
      const url = [this.getAPIUrl(), 'log', 'diff'].join('/');
      return this.postAsync({
        url,
        data: {
          TrueDatabaseID: trueID,
          FalseDatabaseID: falseID,
          UserID: userID,
          TenantID: tenantID,
        }
      });
    } catch (ex) {
      console.log(ex);
    }
  }
}

export default new VersionApplicationApi();
